module.exports = __webpack_public_path__ + "static/media/apple-touch-icon.6ed61f9e.png";